import Reveal from "@/components/base/Reveal";
import { updateFeed } from "@/mocks/home";

const typeStyles: Record<string, string> = {
  专题: "bg-primary-100 text-primary-800",
  专区: "bg-accent-100 text-accent-900",
  频道: "bg-secondary-100 text-secondary-900",
};

export default function UpdateStrip() {
  return (
    <section id="updates" className="w-full bg-background-50">
      <div className="mx-auto max-w-shell px-4 pb-6 md:px-6">
        <Reveal>
          <div className="rounded-lg border border-background-200 bg-background-50 px-5 py-6 md:px-8 md:py-8">
            <div className="flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-refresh-line text-lg" />
                </span>
                <div>
                  <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    滚动更新条
                  </h2>
                  <p className="text-xs font-label text-foreground-500">
                    每一分钟都在收录 · 最近 24 小时
                  </p>
                </div>
              </div>
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-label text-secondary-900">
                <i className="ri-time-line text-sm" />
                最后刷新 09:14
              </span>
            </div>

            <ul className="mt-6 divide-y divide-background-200/80">
              {updateFeed.map((item, index) => (
                <li key={`${item.time}-${index}`}>
                  <a
                    href="#updates"
                    className="group flex flex-col gap-3 py-4 sm:flex-row sm:items-center sm:gap-5 cursor-pointer"
                  >
                    <span className="flex shrink-0 items-center gap-3">
                      <span className="font-heading text-sm font-bold tabular-nums text-primary-600">
                        {item.time}
                      </span>
                      <span
                        className={`rounded-md px-2 py-1 text-[11px] font-label ${
                          typeStyles[item.type] ?? "bg-secondary-100 text-secondary-900"
                        }`}
                      >
                        {item.type}
                      </span>
                    </span>

                    <span className="flex-1 text-sm text-foreground-800 transition-colors duration-300 group-hover:text-primary-700 md:text-[15px]">
                      {item.title}
                    </span>

                    <span className="flex shrink-0 items-center gap-4">
                      <span className="inline-flex items-center gap-1 text-xs font-label text-foreground-500">
                        <i className="ri-price-tag-3-line text-sm" />
                        {item.tag}
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-label text-foreground-500">
                        <i className="ri-fire-line text-sm text-primary-500" />
                        {item.heat}
                      </span>
                      <i className="ri-arrow-right-s-line text-lg text-foreground-400 transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}